import React from 'react';
import { Grid } from 'semantic-ui-react';
import CohortVisualisationRows from './CohortVisualisationRows';
import CohortVisibilityChangerRow from '../../components/CohortVisibilityChangerRow';

const CohortVisualisationsGrid = ({
  code,
  category,
  queryAccess,
  allowCohortVisualisations,
  isNew,
}) => (
  <>
    {queryAccess && (
      <Grid>
        {!allowCohortVisualisations && !isNew && (
        <CohortVisibilityChangerRow code={code} category={category} />
        )}
        {allowCohortVisualisations && (
        <CohortVisualisationRows code={code} category={category} isNew={isNew} />
        )}
      </Grid>
    )}
  </>
);

export default CohortVisualisationsGrid;
